<div class="container-fluid spacer-top-navigation">
  <div class="container">
    @if (isPotentialCustomer$ | async) {
      <web-components-back-link />
    }
    @if (service.isAssetAvailable) {
      <instrument-details-knocked-out-hint />
      <instrument-details-instrument-header
        [model]="service.header$ | async"
        [underlying]="service.underlying$ | async"
        [derivativeTopData]="instrumentDetailFacade.derivativeTopData$ | async"
        [isPotentialCustomer]="isPotentialCustomer$ | async"
      />
      @if (isMobileViewport$ | async) {
        <div class="row">
          @if (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Derivative]) {
            <div class="col-12">
              <instrument-details-derivative-base-and-key-data />
            </div>
          }
          <div class="col-12">
            <div class="tile">
              <charts-web-trading-view-chart [model]="service.chart$ | async" (changePeriod)="service.changeChartPeriod($event)" />
            </div>
          </div>
          <div class="col-12">
            @if (displayPosition$ | async) {
              <instrument-details-instrument-position
                [isin]="(service.header$ | async)?.isin"
                [model]="service.position$ | async"
                [priceScale]="(service.header$ | async)?.priceScale"
                [hasAssetTimeline]="(instrumentDetailFacade.assetTimelineInfo$ | async)?.exists"
              />
            }
          </div>
          <div class="col-12">
            <instrument-details-instrument-statistics
              [model]="service.statistics$ | async"
              [instrumentType]="service.instrumentType$ | async"
            />
          </div>
          <div class="col-12">
            @if ((service.baseData$ | async)?.keyData; as keyData) {
              <instrument-details-instrument-key-data [model]="keyData" />
            }
          </div>
          <div class="col-12">
            @if (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Share]) {
              <instrument-details-related-links [isin]="(service.header$ | async).isin" />
            }
          </div>
          <div class="col-12">
            @if (service.displayBaseData$ | async) {
              <instrument-details-instrument-base-data [model]="(service.baseData$ | async)?.baseData" />
            }
          </div>
          @if (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Derivative]) {
            <div class="col-12">
              <instrument-details-derivative-product-description />
            </div>
          }
          <div class="col-12">
            @if (service.documents$ | async) {
              <instrument-details-instrument-documents [model]="service.documents$ | async" />
            }
          </div>
          <ng-container *ngTemplateOutlet="leverageProducts; context: { isMobileView: true }" />
          <div class="col-12">
            @if (
              (service.header$ | async)?.isin &&
              (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Share, InstrumentType.Derivative])
            ) {
              <instrument-details-instrument-news [model]="service.news$ | async" />
            }
          </div>
          <div class="col-12">
            @if ((service.baseData$ | async)?.dividends; as dividends) {
              <instrument-details-instrument-dividends [model]="dividends" />
            }
          </div>
          <div class="col-12">
            @if ((service.baseData$ | async)?.profile; as profile) {
              <instrument-details-instrument-profile [model]="profile" />
            }
          </div>
          <div class="col-12">
            @if (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Index]) {
              <instrument-details-instrument-topflop [model]="service.indexTopflop$ | async" />
            }
          </div>
        </div>
      } @else {
        <div class="row">
          <div class="col-12 col-lg-8">
            @if (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Derivative]) {
              <instrument-details-derivative-base-and-key-data />
            }
            <div class="tile">
              <charts-web-trading-view-chart [model]="service.chart$ | async" (changePeriod)="service.changeChartPeriod($event)" />
            </div>

            @if (displayOrdermask$ | async) {
              @if (service.header$ | async; as header) {
                <trade [isin]="header.isin" />
              }
            }
            <ng-container *ngTemplateOutlet="leverageProducts; context: { isMobileView: false }" />
            @if (
              (service.header$ | async)?.isin &&
              (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Share, InstrumentType.Derivative])
            ) {
              <instrument-details-instrument-news [model]="service.news$ | async" />
            }
            @if ((service.baseData$ | async)?.profile; as profile) {
              <instrument-details-instrument-profile [model]="profile" />
            }
          </div>
          <div class="col-12 col-lg-4">
            @if (displayPosition$ | async) {
              <instrument-details-instrument-position
                [isin]="(service.header$ | async)?.isin"
                [model]="service.position$ | async"
                [priceScale]="(service.header$ | async)?.priceScale"
                [hasAssetTimeline]="(instrumentDetailFacade.assetTimelineInfo$ | async)?.exists"
              />
            }
            @if (service.statistics$ | async; as statistics) {
              <instrument-details-instrument-statistics [model]="statistics" [instrumentType]="service.instrumentType$ | async" />
            }
            @if ((service.baseData$ | async)?.keyData; as keyData) {
              <instrument-details-instrument-key-data [model]="keyData" />
            }
            @if (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Share]) {
              <instrument-details-related-links [isin]="(service.header$ | async).isin" />
            }
            @if (service.displayBaseData$ | async) {
              <instrument-details-instrument-base-data [model]="(service.baseData$ | async)?.baseData" />
            }
            @if (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Derivative]) {
              <instrument-details-derivative-product-description />
            }
            @if (service.documents$ | async; as documents) {
              <instrument-details-instrument-documents [model]="documents" />
            }
            @if ((service.baseData$ | async)?.dividends; as dividends) {
              <instrument-details-instrument-dividends [model]="dividends" />
            }
          </div>
          <div class="col-12">
            @if (service.instrumentType$ | async | equalsInstrumentType: [InstrumentType.Index]) {
              <instrument-details-instrument-topflop [model]="service.indexTopflop$ | async" />
            }
          </div>
        </div>
      }
    } @else {
      <p>
        {{ 'instrument-detail.asset-unavailable.msg' | transloco }}
      </p>
      <p>
        <a
          class="link-secondary"
          [routerLink]="homeUrl"
          [innerHTML]="'instrument-detail.asset-unavailable.link' | transloco"
          [attr.aria-label]="'instrument-detail.asset-unavailable.link' | transloco"
        ></a>
      </p>
    }
  </div>
</div>

<ng-template #leverageProducts let-isMobileView="isMobileView">
  @if (service.header$ | async; as header) {
    <div [class.col-12]="isMobileView">
      @if (
        header.isin &&
        (service.instrumentType$
          | async
          | equalsInstrumentType
            : [InstrumentType.Share, InstrumentType.Derivative, InstrumentType.Index, InstrumentType.Commodity, InstrumentType.Currency])
      ) {
        <ng-container
          *ngTemplateOutlet="
            leverageProductsBox;
            context: {
              isin: header.isin,
              name: header.name,
              underlyingIsin: header.underlyingIsin,
              underlyingName: header.underlyingName,
            }
          "
        />
      } @else if (header.isin === 'XC000A2YY6Q6') {
        <ng-container *ngTemplateOutlet="leverageProductsBox; context: { isin: 'US12573M4006', name: 'Bitcoin Future' }" />
      }
    </div>
  }
</ng-template>

<ng-template #leverageProductsBox let-isin="isin" let-name="name" let-underlyingIsin="underlyingIsin" let-underlyingName="underlyingName">
  <div class="tile">
    <leverage-products
      [isin]="isin"
      [name]="name"
      [underlyingIsin]="underlyingIsin"
      [underlyingName]="underlyingName"
      [initialNumberOfProducts]="10"
    />
  </div>
</ng-template>
